import { z } from 'zod';

export const vaultRootResponseSchema = z.object({
  service: z.string(),
  version: z.string(),
  status: z.string(),
  timestamp: z.string(),
  gitCommit: z.string(),
  deployedAt: z.string(),
});

export type IVaultRootResponse = z.infer<typeof vaultRootResponseSchema>;
